// extracted by mini-css-extract-plugin
export default {"root":"mJF3rlJl4L"};